export function createClickOutsideListener(selectors: string[], callback: () => void) {
  const handleClickOutside = (e: MouseEvent) => {
    const target = e.target as HTMLElement;

    const isClickOutside = selectors.every((selector) => {
      return !target.closest(selector);
    });

    if (isClickOutside) {
      callback();
    }
  };

  return {
    start: () => {
      document.addEventListener('mousedown', handleClickOutside);
    },
    stop: () => {
      document.removeEventListener('mousedown', handleClickOutside);
    },
  };
}
